import { DeliveryStatusEnum } from '@/service/client/Delivery.type';
import { OrderTypeEnum } from '@/service/model/enums';
import { OptionItem } from '@/service/model/types';

export const LayoutComponentsData = [];

export const DataSourceOfField: OptionItem[] = [
  { label: '公司基础信息', value: 'tenant' },
  { label: '商品类型', value: 'goods_type' },
  { label: '生产商', value: 'producer' },
  { label: '颜色', value: 'colors' },
  { label: '品牌', value: 'brand' },
  { label: '安全技术类别', value: 'security-kind' },
  { label: '安全技术类别分类', value: 'security-kind-type' },
  { label: '执行标准', value: 'standards' },
  { label: '水洗标组', value: 'washing_group' },
  { label: '尺码表', value: 'sizes' },
  { label: '企业69码', value: 'goods_code' },
  { label: '品名', value: 'prodcut-name' },
  { label: '注意事项', value: 'washing_attentions' },
  { label: '特殊说明', value: 'washing_special' },
];

export const DataSourceOfFieldMap = {
  tenant: '公司基础信息',
  goods_type: '商品类型',
  producer: '生产商',
  colors: '颜色',
  brand: '品牌',
  'security-kind': '安全技术类别',
  standards: '执行标准',
  washing_group: '水洗标组',
  sizes: '尺码表',
  goods_code: '企业69码',
  'security-kind-type': '安全技术类别分类',
  washing_attentions: '注意事项',
  washing_special: '特殊说明',
  'prodcut-name': '品名',
};

// TODO: 这里改, 服务端 批量导入sku的接口中 也要改;
export const KindMapping: Record<string, string> = {
  audlt: '成人',
  child: '儿童',
  baby: '婴儿',
};

export const KindOpts: Array<OptionItem> = Object.keys(KindMapping).map(
  (d) => ({
    label: KindMapping[d],
    value: d,
  })
);

// TODO: 这里改, 服务端 批量导入sku的接口中 也要改;
export const SexMapping: Record<string, string> = {
  male: '男',
  female: '女',
};

export const SexOpts: Array<OptionItem> = [
  { label: '男', value: 'male' },
  { label: '女', value: 'female' },
];

// TODO: 这里改, 服务端 批量导入sku的接口中 也要改;
export const TypesOpts: Array<OptionItem> = [
  { label: '上装', value: 'tops' },
  { label: '下装', value: 'bottoms' },
  { label: '套装 (上衣下衣)', value: 'suit_up_down' },
  { label: '套装', value: 'suit' },
  { label: '套裙', value: 'skirt' },
  { label: '亲子装', value: 'parent_child' },
  { label: '通码下装', value: 'fre_bottoms' },
  { label: '连体衣', value: 'bodysuit' },
  { label: '连体衣（无上装）', value: 'bodysuit_no_tops' },
  { label: '套装（长裙+短裤）', value: 'suit_skirt_shorts' },
];

export const TypeMapping: Record<string, string> = TypesOpts.reduce(
  (acc, item) => {
    acc[item.value] = item.label;
    return acc;
  },
  {}
);

// TODO: 这里改, 服务端 批量导入sku的接口中 也要改;
// free代表 无固定配件
export const CategoryMapping: Record<string, string> = {
  clothing: '服装',
  shoes: '鞋',
  pack: '包',
  socks: '袜子',
  glove: '手套',
  hat: '帽子',
  bra: '文胸',
  scarf: '围巾',
};

export const CategoryOpts: Array<OptionItem> = Object.keys(CategoryMapping).map(
  (d) => ({
    label: CategoryMapping[d],
    value: d,
  })
);

export const ComponentTypeMap = {
  field: '动态字段',
  'bar-code': '条形码',
  image: '图片',
  'washing-h': '横向洗涤标',
  'washing-v': '纵向洗涤标',
  'qr-code': '二维码',
  'rich-text': '注意事项/特殊说明',
  'virtual-data': '虚拟容器',
  'plain-text': '纯文本',
  ingredient: '结构化成分',
};

export enum OrderStatus {
  /**
   * 新创建, 待提交审核
   */
  New = 1,
  /**
   * 已提交审核, 待审核
   */
  Submited = 6,
  /**
   * 已作废(不结算)
   */
  Droped = 3,
  /**
   * 已生产作废(结算)
   */
  ProductedDroped = 10,
  /**
   * 审核通过
   */
  Audited = 2,
  /**
   * 审核不通过
   */
  Rejected = 4,
  /**
   * 生产中
   */
  Producting = 5,
  /**
   * 生产完成
   */
  Producted = 7,
  /**
   * 已出货
   */
  Deliveryed = 8,
  /**
   * 已确认收货
   */
  Confirmed = 9,
}

export const OrderStatusMapping: Record<OrderStatus, string> = {
  [OrderStatus.New]: '待提交审核',
  [OrderStatus.Submited]: '待审核',
  [OrderStatus.Droped]: '已作废',
  [OrderStatus.ProductedDroped]: '已生产作废',
  [OrderStatus.Audited]: '审核通过',
  [OrderStatus.Rejected]: '审核未通过',
  [OrderStatus.Producted]: '生产完成',
  [OrderStatus.Producting]: '生产中',
  [OrderStatus.Deliveryed]: '配送中',
  [OrderStatus.Confirmed]: '已确认收货',
};

export const OrderTypeMapping: Record<OrderTypeEnum, string> = {
  [OrderTypeEnum.Normal]: '正常订单',
  [OrderTypeEnum.Logistics]: '物流补单',
};

export const OrderStatusOptions: Array<OptionItem<number>> = Object.keys(
  OrderStatusMapping
).map((key) => ({
  label: OrderStatusMapping[key],
  value: Number(key),
}));

export const OrderTypeOptions: Array<OptionItem<number>> = Object.keys(
  OrderTypeMapping
).map((key) => ({
  value: Number(key),
  label: OrderTypeMapping[key],
}));

export const SupplierStatusMapping: Record<number, string> = {
  [OrderStatus.Audited]: '待接单',
  [OrderStatus.Producting]: '生产中',
  [OrderStatus.Producted]: '生产完成',
  [OrderStatus.Deliveryed]: '已出货',
  [OrderStatus.Confirmed]: '已确认收货',
};

export const DeliveryStatusMapping: Record<DeliveryStatusEnum, string> = {
  [DeliveryStatusEnum.New]: '新创建',
  [DeliveryStatusEnum.Confirmed]: '已确认',
  [DeliveryStatusEnum.Removed]: '已作废',
};

/**
 * 动态字段 具名消费, 要求商品信息字段的code必须是这些, 不然程序不能正常读到数据;
 */
export enum HardCodeField {
  // 颜色_英文
  COLOR = 'colour',
  // 颜色_中文
  COLOR_CN = 'colorch',
  // 颜色编码
  COLOR_CODE = 'ColorCode',
  // 尺码
  SIZE = 'size',
  // 款号
  STYLE_NUMBER = 'ModelNumber',
  // 品名
  PRODUCT_NAME = 'ProductName',
  // 成分
  Ingredient = 'Component',
  // 多语言结构化成分 数据容器
  StructIngredient = 'StructIngredient',
  // 唯一码
  UniqueCode = 'UniqueCode',
  // 二维码-唯一码
  UniqueQrCode = 'UniqueQrCode',
  // 批次
  BatchCode = 'batches',
  // 洗涤组
  WASHING_GROUP = 'WashingGroup',
  // 特殊说明
  Special_comment = 'SpecialComment',
  Special_comment_JP = 'JpSpecialComment',
  Special_comment_EN = 'EnSpecialComment',
  Special_comment_KR = 'KrSpecialComment',
  // sku 69码
  SKU_69Code = 'Sku69Code',
  // 产地
  OriginCity = 'OriginCity',
  // 产标
  ProducerFlag = 'ProducerFlag',
  // 检验员
  InspectorName = 'InspectorName',
  // 婴童特殊安全技术类别分类
  SecuritySpecialType = 'SecuritySpecialType',
}

export const HardCodeFieldOptions: Array<OptionItem<HardCodeField>> = [
  { value: HardCodeField.COLOR, label: '英文颜色' },
  { value: HardCodeField.COLOR_CN, label: '中文颜色' },
  { value: HardCodeField.COLOR_CODE, label: '颜色编码' },
  { value: HardCodeField.SIZE, label: '尺码' },
  { value: HardCodeField.STYLE_NUMBER, label: '款号' },
  { value: HardCodeField.Ingredient, label: '成分' },
  { value: HardCodeField.UniqueCode, label: '唯一码(条形码)' },
  { value: HardCodeField.UniqueQrCode, label: '唯一码(二维码)' },
  { value: HardCodeField.BatchCode, label: '批次号' },
  { value: HardCodeField.Special_comment, label: '特殊说明(中文)' },
  { value: HardCodeField.Special_comment_JP, label: '特殊说明(日文)' },
  { value: HardCodeField.Special_comment_EN, label: '特殊说明(英文)' },
  { value: HardCodeField.Special_comment_KR, label: '特殊说明(韩文)' },
  { value: HardCodeField.SKU_69Code, label: 'SKU 69码' },
  { value: HardCodeField.OriginCity, label: '产地' },
  { value: HardCodeField.ProducerFlag, label: '产标' },
  { value: HardCodeField.InspectorName, label: '检验员' },
  { value: HardCodeField.StructIngredient, label: '多语言成分' },
  {
    value: HardCodeField.SecuritySpecialType,
    label: '婴童特殊安全技术类别分类',
  },
];

export const Key_Menu_Click = 'key_menu_click_bpaos';

export const LogisticsCompanys = {
  sf: '顺丰',
  db: '德邦',
  jd: '京东',
};
/**
 * 语言和图标标准的对应关系
 */
export const LangIconMap = {
  chinese_cn: 'ios_icon',
  english: 'ios_icon',
  japanese: 'jis_icon',
  korean: 'nmx_icon',
};

export const ColorStatusOptions: OptionItem<number>[] = [
  { value: 1, label: '使用中' },
  { value: 2, label: '已下架' },
  { value: 3, label: '已删除' },
];
/**
 * 这些接口调用, 可以通过"配置管理" 灵活切换nodejs 或 java
 */
export const IfJavaMapping = {
  OSSJava: 'oss_java',
  OssClsQuery: 'oss_cls_query',
  GoodsDataDetail: 'goods_data_detail',
  GoodsDataSearch: 'goods_data_search',
  GoodsDataCreate: 'goods_data_create',
  GoodsDataUpdate: 'goods_data_update',
  GoodsDataSubCreate: 'goods_data_sub_create',
  GoodsDataSubDetail: 'goods_data_sub_detail',
  OrderSearch: 'order_search',
  OrderList: 'order_list',
  OrderCreate: 'order_create',
  OrderDetail: 'order_detail',
  OrderUpdate: 'order_update',
  OrderSubmitAudit: 'order_submit_audit',
  OrderBatchConfirm: 'order_batch_confirm',
  OrderSearchAudit: 'order_search_audit',
  OrderRemove: 'order_remove',
  OrderSetProductSample: 'order_set_product_sample',
  OrderSuppliersDeliveryOrders: 'order_suppliers_delivery_orders',
  OrderUniqueCodeGet: 'order_unique_code_get',
  OrderSetDownloaded: 'order_set_downloaded',
  OrderSearchOrderSkus: 'order_search_order_skus',
  OrderExportOrderSkus: 'order_export_order_skus',
  OrderSearchBatchNum: 'order_search_batch_num',
  SuppliersQuery: 'suppliers_query',
  TemplateList: 'template_list',
  TemplateDetail: 'template_detail',
  TenantDics: 'tenant_dics',
  TenantSearchBySupplier: 'tenant_search_by_supplier',
  TenantAdd: 'tenant_add',
  TenantRemove: 'tenant_remove',
  PrintTask: 'print_task',
  PrintData: 'print_data',
  PrintTerminateTask: 'print_terminate_task',
  PrintTaskDetail: 'print_task_detail',
  PrintPreviewPdfImg: 'print_preview_pdf_img',
  PrintTaskDataFree: 'print_task_data_free',
  DeliveryCreate: 'delivery_create',
  DeliverySearch: 'delivery_search',
  DeliveryAudit: 'delivery_audit',
  DeliveryDetail: 'delivery_detail',
  DeliveryUpdate: 'delivery_update',
  DeliveryFormData: 'delivery_form_data',
  ProducerDetail: 'producer_detail',
  SecurityTypeCreate: 'security_type_create',
  SecurityTypeUpdate: 'security_type_update',
  ToolsMockSave: 'tools_mock_save',
  ToolsMock: 'tools_mock',
  ToolsJobs: 'tools_jobs',
  ToolsJobsCreate: 'tools_jobs_create',
  ToolsJobsUpdate: 'tools_jobs_update',
  ToolsJobsDelete: 'tools_jobs_delete',
  ToolsJobsLaunch: 'tools_jobs_launch',
  ToolsRequestSend: 'tools_request_send',
  WashingGroupSearchByIds: 'washing_group_search_by_ids',
  SizeSearchByIds: 'size_search_by_ids',
  StyleNumMatch: 'style_num_match',
};
